import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import mixins from '@/mixins';
import { report } from '@/api/report';
import { queryRechargePackage, createStripeOrder } from '@/api/shop';
import AreaLoading from '@/components/AreaLoading/AreaLoading.vue';
import { sleep } from '@/utils/util.js';

// 4242 4242 4242 4242
export default {
  name: 'Home',

  mixins: [mixins],

  data() {
    return {
      currentYear: new Date().getFullYear(),
      dataList: [],
      initial: false,
      pageLoading: false,
      payType: 'stripe',
      tabList: [
        {
         id: 'stripe',
         name: 'Stripe'
        },
      ]
    }
  },

  computed: {
    ...mapGetters(['userToken', 'appid', 'redirectURL', 'userName', 'userId', 'isLogin', 'balance', 'photo']),
  },

  methods: {
    async init() {
      this.setRootRemSize();
      await sleep(10);
      this.initial = true;
      this.renderGoodsList();
    },

    setRootRemSize () {
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const rootFontSize = viewportWidth / 1125;
      const rootTag = document.querySelector('html');

      rootTag.style.fontSize = rootFontSize + 'px';
    },

    onTabChange(params) {
      this.payType = params.activeId;
      this.renderGoodsList();
    },

    async renderGoodsList() {
      const userToken = this.userToken || '';
      const appid = this.appid || '';
      const payTypeNow = this.payType;
      const requestPayTypes = {
        apple: 0,
        usdt: 1,
        stars: 2,
        paddle: 3,
        stripe: 4
      };

      this.dataList = [];
      this.pageLoading = true;

      try {
        const res = await queryRechargePackage({
          token: userToken,
          appid,
          type: requestPayTypes[payTypeNow] || 0
        });

        if (payTypeNow !== this.payType) {
          return;
        }

        this.dataList = this.makeRenderList(res.data.list);
      }
      catch(err) {}
      this.pageLoading = false;
    },

    async buy(item) {
      if (!this.isLogin) {
        return;
      }

      const userToken = this.userToken || '';

      if (item.type === 'stripe') {
        this.payByStripe(item);
        return;
      }
    },

    async payByStripe(item) {
      const loading = Loading.service({
        fullscreen: true,
        customClass: 'text-loading',
        text: 'Payment connecting...'
      });
      const userToken = this.userToken || '';
      const appid = this.appid || '';

      report({
        event_type: 'click',
        event_value: `click_goods_${item.price}`,
        appid: this.appid
      });

      try {
        const res = await createStripeOrder({
          appid,
          token: userToken,
          package_id: item.id,
          success_url: this.redirectURL,
          cancel_url: window.location.href
        });
        
        window.location.href = res.data.pay_url;
      }
      catch(err) {
        console.log(err);
        loading.close();
        if (err.code) {
          this.$message({
            message: err.message,
            type: 'error',
            showClose: true,
            customClass: 'custom-message',
          });
          return;
        }
        this.$message({
          message: 'Payment fail.',
          type: 'error',
          showClose: true,
          customClass: 'custom-message',
        });
      }
    },

    makeRenderList(srcList) {
      return srcList.map((item) => {
        let price = `$${item.price}`;

        return {
          id: item.package_id,
          diamonds: item.gems,
          price,
          extra: `${item.extra}%`,
          type: this.payType
        }
      });
    }
  },

  mounted() {
    this.init();
    report({
      event_type: 'view',
      event_value: 'shop',
      appid: this.appid
    });
  },

  components: {
    AreaLoading,
  }
}
